import { Context } from '@nuxt/types'
import { UpdateMessage } from '@/lib/broadcasting/messages'

// '.App\\Events\\Booking\\Status\\Completed'
export default (ctx: Context) => {
  return (e: UpdateMessage) => {
    ctx.store.commit('meeting/SET_COMPLETE', e.data.booking.id)
  }
}
